import { CALL_API, CONTENT_TYPE } from 'middlewares/api';
import fetchData from 'utils/api';
import { url } from 'configs/';
const {
  NEWTUBE_API_SERVER,
} = url;
import {
  downloadFile,
} from 'containers/App/screens/Tube/utils/downloadFile';

const FETCH_MANAGEMENT_NEWSLIST_REQUEST = 'tube/departmentnews/management/FETCH_MANAGEMENT_NEWSLIST_REQUEST';
const FETCH_MANAGEMENT_NEWSLIST_SUCCESS = 'tube/departmentnews/management/FETCH_MANAGEMENT_NEWSLIST_SUCCESS';
const FETCH_MANAGEMENT_NEWSLIST_FAILURE = 'tube/departmentnews/management/FETCH_MANAGEMENT_NEWSLIST_FAILURE';
const FETCH_MANAGEMENT_NEWS_REQUEST = 'tube/departmentnews/management/FETCH_MANAGEMENT_NEWS_REQUEST';
const FETCH_MANAGEMENT_NEWS_SUCCESS = 'tube/departmentnews/management/FETCH_MANAGEMENT_NEWS_SUCCESS';
const FETCH_MANAGEMENT_NEWS_FAILURE = 'tube/departmentnews/management/FETCH_MANAGEMENT_NEWS_FAILURE';
const POST_MANAGEMENT_NEWS_REQUEST = 'tube/departmentnews/management/POST_MANAGEMENT_NEWS_REQUEST';
const POST_MANAGEMENT_NEWS_SUCCESS = 'tube/departmentnews/management/POST_MANAGEMENT_NEWS_SUCCESS';
const POST_MANAGEMENT_NEWS_FAILURE = 'tube/departmentnews/management/POST_MANAGEMENT_NEWS_FAILURE';
const PUT_MANAGEMENT_NEWS_REQUEST = 'tube/departmentnews/management/PUT_MANAGEMENT_NEWS_REQUEST';
const PUT_MANAGEMENT_NEWS_SUCCESS = 'tube/departmentnews/management/PUT_MANAGEMENT_NEWS_SUCCESS';
const PUT_MANAGEMENT_NEWS_FAILURE = 'tube/departmentnews/management/PUT_MANAGEMENT_NEWS_FAILURE';
const DELETE_MANAGEMENT_NEWS_REQUEST = 'tube/departmentnews/management/DELETE_MANAGEMENT_NEWS_REQUEST';
const DELETE_MANAGEMENT_NEWS_SUCCESS = 'tube/departmentnews/management/DELETE_MANAGEMENT_NEWS_SUCCESS';
const DELETE_MANAGEMENT_NEWS_FAILURE = 'tube/departmentnews/management/DELETE_MANAGEMENT_NEWS_FAILURE';
const UPLOAD_MANAGEMENT_NEWSFILE_REQUEST = 'tube/departmentnews/management/UPLOAD_MANAGEMENT_NEWSFILE_REQUEST';
const UPLOAD_MANAGEMENT_NEWSFILE_SUCCESS = 'tube/departmentnews/management/UPLOAD_MANAGEMENT_NEWSFILE_SUCCESS';
const UPLOAD_MANAGEMENT_NEWSFILE_FAILURE = 'tube/departmentnews/management/UPLOAD_MANAGEMENT_NEWSFILE_FAILURE';
const FETCH_MANAGEMENT_ENROLLMENT_REQUEST = 'tube/departmentnews/management/FETCH_MANAGEMENT_ENROLLMENT_REQUEST';
const FETCH_MANAGEMENT_ENROLLMENT_SUCCESS = 'tube/departmentnews/management/FETCH_MANAGEMENT_ENROLLMENT_SUCCESS';
const FETCH_MANAGEMENT_ENROLLMENT_FAILURE = 'tube/departmentnews/management/FETCH_MANAGEMENT_ENROLLMENT_FAILURE';
const DELETE_MANAGEMENT_NEWSFILE_REQUEST = 'tube/departmentnews/management/DELETE_MANAGEMENT_NEWSFILE_REQUEST';
const DELETE_MANAGEMENT_NEWSFILE_SUCCESS = 'tube/departmentnews/management/DELETE_MANAGEMENT_NEWSFILE_SUCCESS';
const DELETE_MANAGEMENT_NEWSFILE_FAILURE = 'tube/departmentnews/management/DELETE_MANAGEMENT_NEWSFILE_FAILURE';
const GET_DOWNLOADEXCEL_MANAGEMENTENROLLMENT_REQUEST = 'tube/companynews/management/GET_DOWNLOADEXCEL_MANAGEMENTENROLLMENT_REQUEST';
const GET_DOWNLOADEXCEL_MANAGEMENTENROLLMENT_SUCCESS = 'tube/companynews/management/GET_DOWNLOADEXCEL_MANAGEMENTENROLLMENT_SUCCESS';
const GET_DOWNLOADEXCEL_MANAGEMENTENROLLMENT_ERROR = 'tube/companynews/management/GET_DOWNLOADEXCEL_MANAGEMENTENROLLMENT_ERROR';
export default function reducer(state = {
  newsList: [],
  news: {},
  error: {},
  meta: {}, // 分頁資訊
  isGridFetching: false,
  isFetching: false,
}, action) {
  switch (action.type) {
    case FETCH_MANAGEMENT_NEWS_FAILURE:
    case POST_MANAGEMENT_NEWS_FAILURE:
    case PUT_MANAGEMENT_NEWS_FAILURE:
    case DELETE_MANAGEMENT_NEWS_FAILURE:
      {
        return Object.assign({}, state, {
          error: action.error,
          isFetching: false,
        });
      }
    case FETCH_MANAGEMENT_NEWSLIST_REQUEST:
      {
        return Object.assign({}, state, { isGridFetching: true });
      }
    case FETCH_MANAGEMENT_NEWSLIST_SUCCESS:
      {
        const httpStatusCode = Number(action.response.meta.httpStatusCode);
        let list = [];
        let meta = {};
        if (httpStatusCode === 200 && action.response.hasOwnProperty('data')) {
          list = action.response.data;
          meta = action.response.meta;
        }
        return Object.assign({}, state, {
          newsList: list,
          isGridFetching: false,
          meta,
        });
      }
    case FETCH_MANAGEMENT_NEWSLIST_FAILURE:
      {
        return Object.assign({}, state, {
          error: action.error,
          isGridFetching: false,
        });
      }
    case FETCH_MANAGEMENT_NEWS_REQUEST:
    case FETCH_MANAGEMENT_ENROLLMENT_REQUEST:
      {
        return Object.assign({}, state, {
          isFetching: true,
        });
      }
    case FETCH_MANAGEMENT_NEWS_SUCCESS:
    case FETCH_MANAGEMENT_ENROLLMENT_SUCCESS:
      {
        const httpStatusCode = Number(action.response.meta.httpStatusCode);
        let data = {};
        if (httpStatusCode === 200 && action.response.hasOwnProperty('data')) {
          data = action.response.data;
        }
        return Object.assign({}, state, {
          isFetching: false,
          news: data,
        });
      }
    default:
      return state;
  }
}

/* 列表消息查詢(管理畫面) */
export function fetchManagementNewsList(pageNumber) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}NewsDepartment/Announcement/Management?pageNumber=${pageNumber}`,
      method: 'GET',
      types: [
        FETCH_MANAGEMENT_NEWSLIST_REQUEST,
        FETCH_MANAGEMENT_NEWSLIST_SUCCESS,
        FETCH_MANAGEMENT_NEWSLIST_FAILURE,
      ],
    },
  };
}

/* 消息查詢單筆(管理畫面) */
export function fetchManagementNews(announcementId) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}NewsDepartment/Announcement/Management/${announcementId}`,
      method: 'GET',
      types: [
        FETCH_MANAGEMENT_NEWS_REQUEST,
        FETCH_MANAGEMENT_NEWS_SUCCESS,
        FETCH_MANAGEMENT_NEWS_FAILURE,
      ],
    },
  };
}

/* 新增單筆 */
export function postManagementNews(data) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}NewsDepartment/Announcement/Management`,
      method: 'POST',
      params: data,
      types: [
        POST_MANAGEMENT_NEWS_REQUEST,
        POST_MANAGEMENT_NEWS_SUCCESS,
        POST_MANAGEMENT_NEWS_FAILURE,
      ],
    },
  };
}

/* 修改單筆 */
export function putManagementNews(announcementId, data) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}NewsDepartment/Announcement/Management/${announcementId}`,
      method: 'PUT',
      params: data,
      types: [
        PUT_MANAGEMENT_NEWS_REQUEST,
        PUT_MANAGEMENT_NEWS_SUCCESS,
        PUT_MANAGEMENT_NEWS_FAILURE,
      ],
    },
  };
}

/* 刪除消息 */
export function deleteManagementNews(announcementId) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}NewsDepartment/Announcement/Management/${announcementId}`,
      method: 'DELETE',
      types: [
        DELETE_MANAGEMENT_NEWS_REQUEST,
        DELETE_MANAGEMENT_NEWS_SUCCESS,
        DELETE_MANAGEMENT_NEWS_FAILURE,
      ],
    },
  };
}

/* 上傳附件 */
export function uploadManagementNewsFile(announcementId, formData) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}NewsDepartment/Announcement/Management/${announcementId}/Attachment`,
      method: 'POST',
      types: [
        UPLOAD_MANAGEMENT_NEWSFILE_REQUEST,
        UPLOAD_MANAGEMENT_NEWSFILE_SUCCESS,
        UPLOAD_MANAGEMENT_NEWSFILE_FAILURE,
      ],
      contentType: CONTENT_TYPE.FORM,
      params: formData,
    },
  };
}

/* 刪除附件 */
export function deleteManagementNewsFile(announcementId) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}NewsDepartment/Announcement/Management/${announcementId}/Attachment`,
      method: 'DELETE',
      types: [
        DELETE_MANAGEMENT_NEWSFILE_REQUEST,
        DELETE_MANAGEMENT_NEWSFILE_SUCCESS,
        DELETE_MANAGEMENT_NEWSFILE_FAILURE,
      ],
    },
  };
}

/* 管理介面取得報名資訊 */
export function fetchManagementEnrollment(announcementId) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}NewsDepartment/Enrollment/Management/?AnnouncementId=${announcementId}`,
      method: 'GET',
      types: [
        FETCH_MANAGEMENT_ENROLLMENT_REQUEST,
        FETCH_MANAGEMENT_ENROLLMENT_SUCCESS,
        FETCH_MANAGEMENT_ENROLLMENT_FAILURE,
      ],
    },
  };
}

/* 下載報表清冊 */
export function downloadManagementEnrollment(announcementId) {
  const downloadUrl = `${NEWTUBE_API_SERVER}NewsDepartment/Enrollment/Management/ExcelReport?AnnouncementId=${announcementId}`;
  const types = [
    GET_DOWNLOADEXCEL_MANAGEMENTENROLLMENT_REQUEST,
    GET_DOWNLOADEXCEL_MANAGEMENTENROLLMENT_SUCCESS,
    GET_DOWNLOADEXCEL_MANAGEMENTENROLLMENT_ERROR,
  ];
  return downloadFile(downloadUrl, types);
}

/* 下載附件 */
export function downloadAnnouncementFile(apiUrl) {
  const fetchOptions = {
    mode: 'cors',
    method: 'GET',
    headers: {},
  };
  let downloadUrl = apiUrl.split('api/')[1];
  fetchOptions.headers['Content-Type'] = 'application/json';
  downloadUrl = `${NEWTUBE_API_SERVER}${downloadUrl}`;
  return fetchData(downloadUrl, fetchOptions);
}



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/containers/App/screens/Tube/screens/DepartmentNews/screens/Admin/reducers/index.js
 **/